var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.offer.services.length && _vm.icons.length)?_vm._l((_vm.icons),function(icon,index){return _c('v-icon',{key:index,staticClass:"me-3",attrs:{"color":"success","title":_vm.$t(icon.title)}},[_vm._v("\n            "+_vm._s(icon.ico)+"\n        ")])}):_c('div',[_c('span',[_vm._v(" ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }